import { storeCreator } from '@/utils/store/store.utils';

import { RolesAndSecurityTabs } from '../role.types';


interface IState {
  currentTab: RolesAndSecurityTabs;
  setCurrentTab: (value: RolesAndSecurityTabs) => void;
}

const useRolesAndSecurityTabsStore = storeCreator<IState>((set) => ({
  currentTab: RolesAndSecurityTabs.ROLES,

  setCurrentTab: (value: RolesAndSecurityTabs) => set(() => ({
    currentTab: value,
  })),
}));

export default useRolesAndSecurityTabsStore;